import React, {useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
import { Select, Space } from 'antd';
import Cookies from 'js-cookie';
var CryptoJS = require("crypto-js");

function TopRight({page}) {
    const [topRight, setTopRight] = useState(false);
    const refTopRight = useRef(null);
    useEffect(() => {
        function handleClickOutsideTopRight(event) {
            if (refTopRight.current && !refTopRight.current.contains(event.target)) {
                setTopRight(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutsideTopRight);
    }, [refTopRight]);
    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };
    const handleTopRight = () => {
        setTopRight(!topRight);
    }
    return (
        <div className="d-flex justify-content-end gap-3 currency_container">
            <div>
                {
                    (page !== 'admin' && page !== 'profile')
                    ?
                    <>
                        <Space wrap>
                            <Select
                                defaultValue="USD"
                                style={{ width: 120 }}
                                onChange={handleChange}
                                disabled={true}
                                // loading
                                className='form-select-header'
                                options={[
                                    { value: 'USD', label: '$ USD' },
                                    // { value: 'RUB', label: '₽ RUB' },
                                ]}
                            />
                        </Space>
                    </>
                    :
                    ''
                }
            </div>
            <div className='right_content'>
                <div className='notification_content'>

                </div>
                <div className='profile_content'>
                    <div className='position-relative profile_symbol' ref={refTopRight}>
                        <div className={(topRight) ? 'cursor-pointer symbol active' : 'cursor-pointer symbol'} onClick={handleTopRight}>
                            <div className="symbol-label bg-light-success text-success">{JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).name.charAt(0)}</div>
                        </div>
                        <div className='dropdown_menu_profile' style={{ display: (topRight) ? 'block' : 'none' }}>

                            <Link to='/profile'>
                                <button type="button" className="logout_btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='me-1'>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.98979 10.2308C5.41138 10.2308 3.20947 10.6206 3.20947 12.1819C3.20947 13.7432 5.39741 14.147 7.98979 14.147C10.5682 14.147 12.7695 13.7565 12.7695 12.1959C12.7695 10.6352 10.5822 10.2308 7.98979 10.2308Z" stroke="#1D8F83" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.98968 8.00393C9.68175 8.00393 11.0532 6.63187 11.0532 4.9398C11.0532 3.24774 9.68175 1.87631 7.98968 1.87631C6.29762 1.87631 4.92556 3.24774 4.92556 4.9398C4.91984 6.62615 6.28238 7.99822 7.96809 8.00393H7.98968Z" stroke="#1D8F83" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg> My Profile
                                </button>
                            </Link>

                            <Link to="/logout">
                                <button type="button" className="logout_btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='me-1'>
                                        <path d="M10.0107 4.92632V4.30432C10.0107 2.94766 8.91066 1.84766 7.55399 1.84766H4.30399C2.94799 1.84766 1.84799 2.94766 1.84799 4.30432V11.7243C1.84799 13.081 2.94799 14.181 4.30399 14.181H7.56066C8.91333 14.181 10.0107 13.0843 10.0107 11.7317V11.103" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M14.5397 8.01424H6.51233" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12.5875 6.0708L14.5395 8.01413L12.5875 9.95813" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg> Log out
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default TopRight;